// extracted by mini-css-extract-plugin
export default {"container":"Kr-z","heading":"Lr-z","text":"Mr-z","info":"Nr-z","link":"Or-z","fullMaxWidth":"Pr-z"};